import { Capacitor } from "@capacitor/core";

export const NATIVE_VIEWPORT_CONTENT =
    "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover";

export function configureNativeViewport({
    isNativePlatform = Capacitor.isNativePlatform(),
    documentRef = typeof document !== "undefined" ? document : undefined
} = {}) {
    if (!isNativePlatform) return false;

    const viewport = documentRef?.querySelector?.('meta[name="viewport"]');
    if (!viewport) return false;

    viewport.setAttribute("content", NATIVE_VIEWPORT_CONTENT);
    return true;
}
